@let userInfo = userInfo$ | async;
@let roleTranslateKey =
  userInfo?.isAdmin ? 'monitoring.user-menu.admin' : 'monitoring.user-menu.user';

<button
  #userMenuTrigger="libDropdownTrigger"
  class="account__menu-button"
  [class.account__menu-button--active]="userMenuTrigger.isOpen"
  [class.account__menu-button--collapsed]="collapsed"
  type="button"
  [libDropdownTrigger]="userMenu"
>
  <lib-svg-icon
    class="account__icon"
    icon="user"
    [size]="24"
  />

  @if (!collapsed) {
    <span class="account__name">{{ userInfo?.userName || '—' }}</span>

    <lib-svg-icon
      class="account__dropdown-icon"
      [style.transform]="userMenuTrigger.isOpen ? 'rotate(180deg)' : ''"
      icon="arrow-down"
      [size]="20"
    />
  }
</button>

<ng-template #userMenu>
  <div
    @scale
    class="account__menu user-menu"
  >
    <span class="user-menu__role">{{ roleTranslateKey | translate }}</span>

    <div class="user-menu__name-wrapper">
      <div class="user-menu__name">{{ userInfo?.userName }}</div>
      <div class="user-menu__email">{{ userInfo?.email }}</div>
    </div>

    <div class="user-menu__buttons">
      <lib-button
        buttonSize="custom"
        class="user-menu__button"
        buttonStyle="ghost"
      >
        <div class="user-menu__button-label">
          <lib-svg-icon icon="key" />
          <span>{{ 'monitoring.user-menu.change-password' | translate }}</span>
        </div>

        <lib-svg-icon icon="arrow-right" />
      </lib-button>

      <lib-button
        buttonSize="custom"
        class="user-menu__button"
        buttonStyle="ghost-secondary"
        (click)="logout()"
      >
        <div class="user-menu__button-label">
          <lib-svg-icon icon="logout" />
          <span>{{ 'monitoring.user-menu.logout' | translate }}</span>
        </div>
      </lib-button>
    </div>
  </div>
</ng-template>
